(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joe-eays"]) return;
  try {
    
(()=>{function setup(){const section=document.querySelector('.eays-page');const trigger=section?.querySelector('[data-eays-letters]');const wrapper=document.querySelector('[id$="__letters"]');if(!trigger||!wrapper)return;wrapper.id='eays-letters';wrapper.hidden=true;trigger.addEventListener('click',event=>{event.preventDefault();const open=trigger.getAttribute('aria-expanded')!=='true';trigger.setAttribute('aria-expanded',String(open));trigger.querySelector('[data-open]').hidden=open;trigger.querySelector('[data-close]').hidden=!open;wrapper.hidden=!open;if(open)wrapper.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();document.addEventListener('shopify:section:load',setup);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joe-header"]) return;
  try {
    
(() => {
let controller;
function initEditorial(){
controller?.abort();controller=new AbortController();
const bind=(element,type,listener)=>element.addEventListener(type,listener,{signal:controller.signal});
if(!document.querySelector('.joe-editorial')) return;
const menuButton=document.querySelector('.menu-toggle');
const nav=document.querySelector('#main-nav');
if(!menuButton || !nav) return;
function closeMenu(){nav.classList.remove('open');menuButton.setAttribute('aria-expanded','false')}
bind(menuButton,'click',()=>{const open=menuButton.getAttribute('aria-expanded')!=='true';menuButton.setAttribute('aria-expanded',String(open));nav.classList.toggle('open',open)});
bind(nav,'click',e=>{if(e.target.closest('a'))closeMenu()});
bind(document,'keydown',e=>{if(e.key==='Escape'&&nav.classList.contains('open')){closeMenu();menuButton.focus()}});
const dialog=document.querySelector('#retailers-dialog');
if(!dialog || !document.querySelector('#buy-button')) return;
bind(document.querySelector('#buy-button'),'click',()=>{dialog.querySelectorAll('.jm-retailers__format').forEach(item=>item.open=false);dialog.showModal();dialog.scrollTop=0;});
bind(document.querySelector('.dialog-close'),'click',()=>dialog.close());
bind(dialog,'click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
const editions={
es:{title:'Entre Ayer y Siempre',cover:'https://joemercado10.com/cdn/shop/files/Front_Covera_Entre_Ayer_y_Siempre_by_Joe_M._Mercado-Rivera_page-0001.jpg?width=500',alt:'Portada de Entre Ayer y Siempre',kicker:'Romance contemporáneo · Ambientado en Puerto Rico',description:'Jay intenta encontrar su camino. Felicity llega con una libertad que él nunca se ha permitido. Entre ellos nace un amor que los obliga a preguntarse cuánto están dispuestos a arriesgar por la vida que desean.',details:'/pages/entre-ayer-y-siempre',buy:'Dónde comprar',sample:'Leer una muestra',sampleUrl:'https://cdn.shopify.com/s/files/1/0808/6582/0976/files/PReview_Entre_Ayer_y_Siempre_-_Joe_M._Mercado_Rivera.pdf?v=1763214940',sampleNote:'Los primeros dos capítulos, gratis en PDF.',detailsLabel:'Conoce la historia'},
en:{title:'Between Yesterday & Forever',cover:'https://joemercado10.com/cdn/shop/files/6.jpg?width=500',alt:'Cover of Between Yesterday & Forever',kicker:'Contemporary romance · Set in Puerto Rico',description:'Jay is searching for his purpose. Felicity arrives with a freedom he has never allowed himself. As they fall in love, both must decide what they are willing to risk for the life they want.',details:'/pages/between-yesterday-forever',buy:'Where to buy',sample:'Explore the story',sampleUrl:'/pages/between-yesterday-forever',sampleNote:'The English edition of Entre Ayer y Siempre.',detailsLabel:'About the English edition'}
};
document.querySelectorAll('[data-edition]').forEach(button=>bind(button,'click',()=>{
const lang=button.dataset.edition,d=editions[lang];document.querySelectorAll('[data-edition]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
const cover=document.querySelector('#book-cover');cover.removeAttribute('srcset');cover.src=d.cover;cover.alt=d.alt;
document.querySelector('#book-title').textContent=d.title;document.querySelector('#book-kicker').textContent=d.kicker;document.querySelector('#book-description').textContent=d.description;document.querySelector('#book-content').lang=lang;
document.querySelector('#buy-button').textContent=d.buy;
const sample=document.querySelector('#sample-link');sample.textContent=d.sample;sample.href=d.sampleUrl;sample.lang=lang;
document.querySelector('#sample-note').textContent=d.sampleNote;const details=document.querySelector('#book-details-link');details.textContent=d.detailsLabel;details.href=d.details;
}));

if(document.documentElement.lang.startsWith("en")) document.querySelector('[data-edition="en"]')?.click();
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initEditorial,{once:true}); else initEditorial();
document.addEventListener('shopify:section:load',initEditorial);
document.addEventListener('shopify:section:unload',()=>setTimeout(initEditorial,0));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joe-letters"]) return;
  try {
    
(() => {
function init(){document.querySelectorAll('[data-letters]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const dialog=root.querySelector('dialog');if(!dialog.showModal)return;
const details=[...root.querySelectorAll('.jl-envelope')],progress=root.querySelector('[data-progress]');let opened=new Set(),active=0,origin;
root.querySelector('.jl-tools').hidden=false;
const update=()=>{progress.textContent=progress.dataset.pattern.replace('[count]',opened.size);details.forEach((d,i)=>d.querySelector('.jl-read').hidden=!opened.has(i));};
const show=(index)=>{active=index;const d=details[index];opened.add(index);update();root.querySelector('[data-modal-sender]').textContent=d.closest('article').querySelector('.jl-moment').textContent+' · '+d.querySelector('.jl-sender').textContent;dialog.querySelector('h2').textContent=d.querySelector('h3').textContent;dialog.querySelector('.jl-letter-text').replaceChildren(...[...d.querySelector('.jl-body').childNodes].map(n=>n.cloneNode(true)));dialog.querySelector('[data-direction="-1"]').disabled=index===0;dialog.querySelector('[data-direction="1"]').disabled=index===details.length-1;if(!dialog.open)dialog.showModal();dialog.scrollTop=0;dialog.querySelector('h2').focus();};
details.forEach((d,i)=>d.querySelector('summary').addEventListener('click',e=>{e.preventDefault();origin=e.currentTarget;show(i)}));
dialog.querySelector('.jl-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>origin?.focus());
dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close();}});
dialog.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>{const n=active+Number(b.dataset.direction);if(n>=0&&n<details.length)show(n)}));
root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));root.querySelectorAll('.jl-card').forEach(card=>card.hidden=b.dataset.filter!=='all'&&card.dataset.person!==b.dataset.filter)}));
root.querySelector('.jl-reset').addEventListener('click',()=>{opened.clear();update()});update();
});}init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joe-site-tools"]) return;
  try {
    
(()=>{let api,loading=false;const root=document.querySelector('#JoePrivacy');if(!root)return;const banner=root.querySelector('.js-cookie-banner'),dialog=root.querySelector('dialog');let opener;
const status=text=>root.querySelectorAll('[data-cookie-status]').forEach(e=>e.textContent=text);
const busy=value=>root.querySelectorAll('[data-consent-choice]').forEach(b=>b.disabled=value);
const sync=()=>{if(!api)return;const c=api.currentVisitorConsent();root.querySelectorAll('[data-consent-purpose]').forEach(i=>i.checked=c[i.dataset.consentPurpose]==='yes');};
const load=()=>{if(api)return Promise.resolve(api);if(loading)return new Promise((res,rej)=>{let tries=0;const poll=setInterval(()=>{if(api){clearInterval(poll);res(api)}else if(++tries>40){clearInterval(poll);rej(new Error('privacy'))}},250)});loading=true;return new Promise((resolve,reject)=>{let attempts=0;const boot=()=>{if(!window.Shopify?.loadFeatures){if(++attempts<40){setTimeout(boot,250);return}loading=false;reject(new Error('privacy'));return}window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],err=>{loading=false;if(err||!window.Shopify.customerPrivacy){reject(err||new Error('privacy'));return}api=window.Shopify.customerPrivacy;resolve(api)});};boot()})};
const open=async trigger=>{opener=trigger;banner.hidden=true;if(dialog.showModal&&!dialog.open)dialog.showModal();busy(true);try{await load();sync();status('');busy(false)}catch(e){status(root.dataset.cookieError)}};
document.querySelectorAll('[data-cookie-open],[data-cookie-configure]').forEach(b=>b.addEventListener('click',()=>open(b)));
root.querySelector('[data-cookie-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{opener?.focus();if(api){const c=api.currentVisitorConsent();banner.hidden=!!(c.analytics||c.marketing||c.preferences)}});
root.querySelectorAll('[data-consent-choice]').forEach(b=>b.addEventListener('click',async()=>{busy(true);status('');try{await load();const choice=b.dataset.consentChoice;const value={};['analytics','marketing','preferences'].forEach(p=>value[p]=choice==='save'?root.querySelector('[data-consent-purpose="'+p+'"]').checked:choice==='accept');api.setTrackingConsent(value,()=>{const c=api.currentVisitorConsent();if(!Object.keys(value).every(k=>c[k]===(value[k]?'yes':'no'))){status(root.dataset.cookieError);busy(false);return}banner.hidden=true;if(dialog.open)dialog.close();sync();busy(false);document.dispatchEvent(new Event('joe:privacy-saved'))})}catch(e){status(root.dataset.cookieError);busy(false)}}));
load().then(()=>{sync();status('');const c=api.currentVisitorConsent();banner.hidden=!!(c.analytics||c.marketing||c.preferences);busy(false)}).catch(()=>{banner.hidden=false;status(root.dataset.cookieError);busy(true)});
document.addEventListener('visitorConsentCollected',()=>{if(api){sync();const c=api.currentVisitorConsent();if(c.analytics||c.marketing||c.preferences)banner.hidden=true;}});
function forms(){document.querySelectorAll('form[data-joe-form]').forEach(form=>{if(form.dataset.joeReady)return;form.dataset.joeReady='true';const fields=[...form.querySelectorAll('input[required],textarea[required]')];const error=form.querySelector('[data-form-error]');const check=field=>{field.setCustomValidity('');if(field.value&&!field.value.trim())field.setCustomValidity(form.dataset.emptyError);else if(field.tagName==='TEXTAREA'&&field.value.trim().length>0&&field.value.trim().length<10)field.setCustomValidity(form.dataset.shortError);field.setAttribute('aria-invalid',String(!field.validity.valid));};fields.forEach(f=>f.addEventListener('input',()=>check(f)));form.addEventListener('submit',event=>{fields.forEach(check);if(form.querySelector('[data-honeypot]')?.value){event.preventDefault();event.stopImmediatePropagation();error.textContent=form.dataset.spamError;error.hidden=false;return}if(!form.checkValidity()){event.preventDefault();error.textContent=form.dataset.formError;error.hidden=false;form.reportValidity();return}error.hidden=true;},true)})}
function media(){document.querySelectorAll('.js-external-media').forEach(box=>{const button=box.querySelector('[data-load-media]');if(!button||button.dataset.bound)return;button.dataset.bound='true';button.addEventListener('click',()=>{const frame=box.querySelector('template').content.firstElementChild.cloneNode(true);frame.src=frame.dataset.consentSrc;frame.removeAttribute('data-consent-src');box.querySelectorAll(':scope > p,:scope > button,:scope > a').forEach(e=>e.hidden=true);box.append(frame);box.classList.add('is-loaded');frame.focus()})})}forms();media();document.addEventListener('shopify:section:load',()=>{forms();media()});
})();

  } catch(e) { console.error(e); }
})();
})();
